// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Board = require("../Data.Board/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Enemy = require("../Data.Enemy/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Item = require("../Data.Item/index.js");
var Data_LinearIndex = require("../Data.LinearIndex/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Terrain = require("../Data.Terrain/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Debug_Trace = require("../Debug.Trace/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var Framework_Direction = require("../Framework.Direction/index.js");
var Mapgen = require("../Mapgen/index.js");
var Random_Gen = require("../Random.Gen/index.js");
var Solver = require("../Solver/index.js");
var TargetEnemy = (function () {
    function TargetEnemy(value0) {
        this.value0 = value0;
    };
    TargetEnemy.create = function (value0) {
        return new TargetEnemy(value0);
    };
    return TargetEnemy;
})();
var TargetItem = (function () {
    function TargetItem(value0) {
        this.value0 = value0;
    };
    TargetItem.create = function (value0) {
        return new TargetItem(value0);
    };
    return TargetItem;
})();
var TargetTerrain = (function () {
    function TargetTerrain(value0) {
        this.value0 = value0;
    };
    TargetTerrain.create = function (value0) {
        return new TargetTerrain(value0);
    };
    return TargetTerrain;
})();
var Regular = (function () {
    function Regular(value0) {
        this.value0 = value0;
    };
    Regular.create = function (value0) {
        return new Regular(value0);
    };
    return Regular;
})();
var Surgery = (function () {
    function Surgery(value0) {
        this.value0 = value0;
    };
    Surgery.create = function (value0) {
        return new Surgery(value0);
    };
    return Surgery;
})();
var NewGame = (function () {
    function NewGame() {

    };
    NewGame.value = new NewGame();
    return NewGame;
})();
var Dead = (function () {
    function Dead() {

    };
    Dead.value = new Dead();
    return Dead;
})();
var Victory = (function () {
    function Victory() {

    };
    Victory.value = new Victory();
    return Victory;
})();
var Move = (function () {
    function Move(value0) {
        this.value0 = value0;
    };
    Move.create = function (value0) {
        return new Move(value0);
    };
    return Move;
})();
var Attack = (function () {
    function Attack(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Attack.create = function (value0) {
        return function (value1) {
            return new Attack(value0, value1);
        };
    };
    return Attack;
})();
var SelectWeapon = (function () {
    function SelectWeapon(value0) {
        this.value0 = value0;
    };
    SelectWeapon.create = function (value0) {
        return new SelectWeapon(value0);
    };
    return SelectWeapon;
})();
var InstallOrgan = (function () {
    function InstallOrgan(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InstallOrgan.create = function (value0) {
        return function (value1) {
            return new InstallOrgan(value0, value1);
        };
    };
    return InstallOrgan;
})();
var RemoveOrgan = (function () {
    function RemoveOrgan(value0) {
        this.value0 = value0;
    };
    RemoveOrgan.create = function (value0) {
        return new RemoveOrgan(value0);
    };
    return RemoveOrgan;
})();
var FinishSurgery = (function () {
    function FinishSurgery() {

    };
    FinishSurgery.value = new FinishSurgery();
    return FinishSurgery;
})();
var StartNewGame = (function () {
    function StartNewGame() {

    };
    StartNewGame.value = new StartNewGame();
    return StartNewGame;
})();
var FailedAction = (function () {
    function FailedAction(value0) {
        this.value0 = value0;
    };
    FailedAction.create = function (value0) {
        return new FailedAction(value0);
    };
    return FailedAction;
})();
var FailedAttack = (function () {
    function FailedAttack() {

    };
    FailedAttack.value = new FailedAttack();
    return FailedAttack;
})();
var FailedInstall = (function () {
    function FailedInstall() {

    };
    FailedInstall.value = new FailedInstall();
    return FailedInstall;
})();
var PlayerMoved = (function () {
    function PlayerMoved(value0) {
        this.value0 = value0;
    };
    PlayerMoved.create = function (value0) {
        return new PlayerMoved(value0);
    };
    return PlayerMoved;
})();
var EnemyMoved = (function () {
    function EnemyMoved(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    EnemyMoved.create = function (value0) {
        return function (value1) {
            return new EnemyMoved(value0, value1);
        };
    };
    return EnemyMoved;
})();
var PlayerAttacked = (function () {
    function PlayerAttacked(value0) {
        this.value0 = value0;
    };
    PlayerAttacked.create = function (value0) {
        return new PlayerAttacked(value0);
    };
    return PlayerAttacked;
})();
var EnemyAttacked = (function () {
    function EnemyAttacked(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    EnemyAttacked.create = function (value0) {
        return function (value1) {
            return new EnemyAttacked(value0, value1);
        };
    };
    return EnemyAttacked;
})();
var PlayerDied = (function () {
    function PlayerDied() {

    };
    PlayerDied.value = new PlayerDied();
    return PlayerDied;
})();
var EnemyDied = (function () {
    function EnemyDied(value0) {
        this.value0 = value0;
    };
    EnemyDied.create = function (value0) {
        return new EnemyDied(value0);
    };
    return EnemyDied;
})();
var RoomRevealed = (function () {
    function RoomRevealed(value0) {
        this.value0 = value0;
    };
    RoomRevealed.create = function (value0) {
        return new RoomRevealed(value0);
    };
    return RoomRevealed;
})();
var ItemUsed = (function () {
    function ItemUsed(value0) {
        this.value0 = value0;
    };
    ItemUsed.create = function (value0) {
        return new ItemUsed(value0);
    };
    return ItemUsed;
})();
var GameState = function (x) {
    return x;
};
var withRandom = function (f) {
    return function (v) {
        var v1 = Random_Gen.runRandom(f(v))(v.rng);
        return {
            p: v1.result.p,
            playerHealth: v1.result.playerHealth,
            playerDistanceMap: v1.result.playerDistanceMap,
            playerWeapons: v1.result.playerWeapons,
            playerCurrentWeapon: v1.result.playerCurrentWeapon,
            enemies: v1.result.enemies,
            items: v1.result.items,
            terrain: v1.result.terrain,
            rooms: v1.result.rooms,
            level: v1.result.level,
            availableOrgans: v1.result.availableOrgans,
            events: v1.result.events,
            rng: v1.nextGen,
            nextId: v1.result.nextId,
            installedOrgans: v1.result.installedOrgans,
            removedOrgans: v1.result.removedOrgans
        };
    };
};
var useItem = function (iid) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: Data_Map_Internal["delete"](Data_Ord.ordInt)(iid)(v.items),
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var startingPos = {
    x: 1,
    y: 1
};
var selectWeapon = function (i) {
    return function (gs) {
        return Extra_Prelude.todo();
    };
};
var rollLocations = function (v) {
    return function (v1) {
        if (v === 0) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)([  ]);
        };
        var candidates = Data_Terrain.blockPositions(v1);
        return Control_Bind.bind(Random_Gen.bindRandom)(Data_Traversable["for"](Random_Gen.applicativeRandom)(Data_Traversable.traversableArray)(Data_Array.range(1)(v))(function (v2) {
            return Random_Gen.unsafeElement("rollLocations")(candidates);
        }))(function (p1) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Array.fromFoldable(Data_Set.foldableSet)(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Extra_Math.ordVector(Data_Ord.ordInt))(p1)));
        });
    };
};
var reportEvent = function (e) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: v.items,
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: Data_Array.cons(e)(v.events),
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var removeOrgan = function (pos) {
    return function (v) {
        var health = Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth);
        var board = Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)(health.board);
        var newBag = Data_Board.removeOrganAt(pos)(board.organs);
        var newBoard = {
            organs: newBag,
            injuries: board.injuries
        };
        var spacesToInjure = Data_Board.organExtent(pos)(board.organs);
        var newHealth = Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Board.injure)(Data_Board.fromBoard(newBoard))(spacesToInjure);
        return {
            p: v.p,
            playerHealth: newHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: v.items,
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var removeAvailableOrgan = function (organ) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: v.items,
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: Data_Board.removeOrganAt(Data_Tuple.snd(organ))(v.availableOrgans),
            events: v.events,
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var playerHpOrgan = new Data_Board.Organ(new Data_Board.OrganSize(2, 2), Data_Board.PlayerHeartLarge.value);
var placeWeapon = function (p) {
    return function (w) {
        return Extra_Prelude.todo();
    };
};
var pickUpWeapon = function (iid) {
    return function (v) {
        return Extra_Prelude.todo();
    };
};
var openDoorAt = function (p) {
    return function (v) {
        var newTerrain = Data_Maybe.fromMaybe(v.terrain)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_LinearIndex.index(v.terrain)(p))(function (t) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(Data_Eq.eq(Data_Terrain.terrainEq)(t)(Data_Terrain.DoorClosed.value)))(function () {
                return Data_LinearIndex.insertAt(p)(Data_Terrain.DoorOpen.value)(v.terrain);
            });
        }));
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: v.items,
            terrain: newTerrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var o = function (organ) {
    return function (weight) {
        return {
            organ: organ,
            weight: weight
        };
    };
};
var nextLevel = function (v) {
    if (v instanceof Regular) {
        var $137 = Debug_Trace.spy()("level i")(v.value0) < 5;
        if ($137) {
            return new Surgery(v.value0);
        };
        return Victory.value;
    };
    if (v instanceof Surgery) {
        return new Regular(v.value0 + 1 | 0);
    };
    if (v instanceof NewGame) {
        return new Regular(1);
    };
    if (v instanceof Dead) {
        return NewGame.value;
    };
    if (v instanceof Victory) {
        return Victory.value;
    };
    throw new Error("Failed pattern match at GameState (line 570, column 1 - line 570, column 28): " + [ v.constructor.name ]);
};
var markVisible = function (room) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: v.items,
            terrain: v.terrain,
            rooms: Data_Map_Internal.update(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "width";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "height";
            }))(Data_Ord.ordInt)))(function (x) {
                return new Data_Maybe.Just({
                    visible: true,
                    perimeter: x.perimeter,
                    room: x.room
                });
            })(room)(v.rooms),
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var levelDepth = function (v) {
    if (v instanceof Regular) {
        return v.value0;
    };
    if (v instanceof Surgery) {
        return v.value0;
    };
    if (v instanceof NewGame) {
        return 0;
    };
    if (v instanceof Victory) {
        return 9001;
    };
    if (v instanceof Dead) {
        return 0;
    };
    throw new Error("Failed pattern match at GameState (line 577, column 1 - line 577, column 27): " + [ v.constructor.name ]);
};
var isWall = function (v) {
    return function (t) {
        return Data_Eq.eq(Data_Terrain.terrainEq)(Data_Terrain.Wall.value)(Data_Maybe.fromMaybe(Data_Terrain.Floor.value)(Data_LinearIndex.index(t)(v)));
    };
};
var isSurgeryLevel = function (v) {
    if (v.level instanceof Surgery) {
        return true;
    };
    return false;
};
var isOpenDoor = function (v) {
    return function (t) {
        return Data_Eq.eq(Data_Terrain.terrainEq)(Data_Terrain.DoorOpen.value)(Data_Maybe.fromMaybe(Data_Terrain.Floor.value)(Data_LinearIndex.index(t)(v)));
    };
};
var isItem = function (v) {
    return function (v1) {
        return Data_Foldable.any(Data_Map_Internal.foldableMap)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Item.itemOnSpace(v))(v1.items);
    };
};
var isFloor = function (v) {
    return function (t) {
        return Data_Eq.eq(Data_Terrain.terrainEq)(Data_Terrain.Floor.value)(Data_Maybe.fromMaybe(Data_Terrain.Floor.value)(Data_LinearIndex.index(t)(v)));
    };
};
var isExit = function (v) {
    return function (v1) {
        var v3 = Data_LinearIndex.index(v1.terrain)(v);
        if (v3 instanceof Data_Maybe.Just && v3.value0 instanceof Data_Terrain.Exit) {
            return true;
        };
        return false;
    };
};
var installOrgan = function (pos) {
    return function (organ) {
        return function (v) {
            var health = Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth);
            var board = Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)(health.board);
            var newBag = Data_Board.insertOrgan(pos)(organ)(board.organs);
            var newBoard = {
                organs: newBag,
                injuries: board.injuries
            };
            return {
                p: v.p,
                playerHealth: Data_Board.fromBoard(newBoard),
                playerDistanceMap: v.playerDistanceMap,
                playerWeapons: v.playerWeapons,
                playerCurrentWeapon: v.playerCurrentWeapon,
                enemies: v.enemies,
                items: v.items,
                terrain: v.terrain,
                rooms: v.rooms,
                level: v.level,
                availableOrgans: v.availableOrgans,
                events: v.events,
                rng: v.rng,
                nextId: v.nextId,
                installedOrgans: v.installedOrgans + 1 | 0,
                removedOrgans: v.removedOrgans
            };
        };
    };
};
var inWorldBounds = function (v) {
    return function (v1) {
        return 0 <= v.x && (v.x <= (v1.width - 1 | 0) && (0 <= v.y && v.y <= (v1.height - 1 | 0)));
    };
};
var isPassable = function (t) {
    return function (v) {
        return inWorldBounds(t)(v.terrain) && (!isWall(t)(v.terrain) && !Data_Foldable.any(Data_Map_Internal.foldableMap)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Enemy.enemyOnSpace(t))(v.enemies));
    };
};
var recalculatePDMap = function (v) {
    var expand = function (x) {
        return Control_Bind.bind(Control_Bind.bindArray)(Framework_Direction.directions8)(function (d) {
            var x$prime = Framework_Direction.move(Data_Ring.ringInt)(d)(x);
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(inWorldBounds(x$prime)(v.terrain)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(isFloor(x$prime)(v.terrain) || isOpenDoor(x$prime)(v.terrain)))(function () {
                    return Control_Applicative.pure(Control_Applicative.applicativeArray)(x$prime);
                });
            });
        });
    };
    var newMap = Solver.distanceMap(v.p)(expand);
    return {
        p: v.p,
        playerHealth: v.playerHealth,
        playerDistanceMap: newMap,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: v.enemies,
        items: v.items,
        terrain: v.terrain,
        rooms: v.rooms,
        level: v.level,
        availableOrgans: v.availableOrgans,
        events: v.events,
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: v.installedOrgans,
        removedOrgans: v.removedOrgans
    };
};
var humanEye = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.HumanEye.value);
var hpOrgan1 = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.Hp.value);
var healOne = function (v) {
    return Control_Bind.bind(Random_Gen.bindRandom)(Data_Board.randomInjuredSpace(v.playerHealth.board))(function (mbc) {
        if (mbc instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(v);
        };
        if (mbc instanceof Data_Maybe.Just) {
            var newI = Data_Set["delete"](Extra_Math.ordVector(Data_Ord.ordInt))(mbc.value0)(v.playerHealth.board.injuries);
            var newB = {
                organs: v.playerHealth.board.organs,
                injuries: newI
            };
            var newH = {
                hpCount: Data_Board.hpCount(newB),
                armorCount: v.playerHealth.armorCount,
                canSee: v.playerHealth.canSee,
                hasSpecialEyes: v.playerHealth.hasSpecialEyes,
                board: newB
            };
            return Control_Applicative.pure(Random_Gen.applicativeRandom)({
                p: v.p,
                playerHealth: newH,
                playerDistanceMap: v.playerDistanceMap,
                playerWeapons: v.playerWeapons,
                playerCurrentWeapon: v.playerCurrentWeapon,
                enemies: v.enemies,
                items: v.items,
                terrain: v.terrain,
                rooms: v.rooms,
                level: v.level,
                availableOrgans: v.availableOrgans,
                events: v.events,
                rng: v.rng,
                nextId: v.nextId,
                installedOrgans: v.installedOrgans,
                removedOrgans: v.removedOrgans
            });
        };
        throw new Error("Failed pattern match at GameState (line 732, column 5 - line 738, column 55): " + [ mbc.constructor.name ]);
    });
};
var healMany = function (v) {
    return function (v1) {
        var $173 = Data_Set.size(v1.playerHealth.board.injuries) > 0;
        if ($173) {
            if (v.tag instanceof Data_Item.HealthPickup) {
                var nHeal = Data_Ord.min(Data_Ord.ordInt)(v.tag.value0)(Data_Set.size(v1.playerHealth.board.injuries));
                return Control_Bind.bind(Random_Gen.bindRandom)(Data_Foldable.foldM(Data_Foldable.foldableArray)(Random_Gen.monadRandom)(function (g) {
                    return function (v2) {
                        return healOne(g);
                    };
                })(v1)(Data_Array.range(1)(v.tag.value0)))(function (newGs) {
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)(newGs);
                });
            };
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(v1);
        };
        return Control_Applicative.pure(Random_Gen.applicativeRandom)(v1);
    };
};
var handleEnemyInjury = function (v) {
    return function (v1) {
        return function (eid) {
            return function (bc) {
                var newE = Data_Enemy.injureEnemy(bc)(v1);
                var $180 = Data_Enemy.isAlive(newE);
                if ($180) {
                    return {
                        p: v.p,
                        playerHealth: v.playerHealth,
                        playerDistanceMap: v.playerDistanceMap,
                        playerWeapons: v.playerWeapons,
                        playerCurrentWeapon: v.playerCurrentWeapon,
                        enemies: Data_Map_Internal.insert(Data_Ord.ordInt)(eid)(newE)(v.enemies),
                        items: v.items,
                        terrain: v.terrain,
                        rooms: v.rooms,
                        level: v.level,
                        availableOrgans: v.availableOrgans,
                        events: v.events,
                        rng: v.rng,
                        nextId: v.nextId,
                        installedOrgans: v.installedOrgans,
                        removedOrgans: v.removedOrgans
                    };
                };
                return reportEvent(new EnemyDied(eid))({
                    p: v.p,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: Data_Map_Internal["delete"](Data_Ord.ordInt)(eid)(v.enemies),
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: v.availableOrgans,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                });
            };
        };
    };
};
var goToNextLevel = function (v) {
    return {
        p: v.p,
        playerHealth: v.playerHealth,
        playerDistanceMap: v.playerDistanceMap,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: v.enemies,
        items: v.items,
        terrain: v.terrain,
        rooms: v.rooms,
        level: nextLevel(v.level),
        availableOrgans: v.availableOrgans,
        events: v.events,
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: v.installedOrgans,
        removedOrgans: v.removedOrgans
    };
};
var getTerrainAtPosition = function (p) {
    return function (v) {
        return Data_Maybe.fromMaybe(Data_Terrain.Floor.value)(Data_LinearIndex.index(v.terrain)(p));
    };
};
var getItemAtPosition = function (p) {
    return function (v) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_FoldableWithIndex.findWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (iid) {
            return function (v1) {
                return Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v1.location)(p);
            };
        })(v.items))(function (v1) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(v1.index);
        });
    };
};
var getItem = function (v) {
    return function (v1) {
        var newM = Data_Map_Internal.filter(Data_Ord.ordInt)(function (v3) {
            return Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v3.location)(v);
        })(v1.items);
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_List.head(Data_Map_Internal.values(newM)))(function (item) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.head(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(newM))))(function (iid) {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                    item: item,
                    iid: iid
                });
            });
        });
    };
};
var getFreeWeaponSlot = function (m) {
    return Data_Foldable.find(Data_Foldable.foldableArray)(function (x) {
        return !Data_Map_Internal.member(Data_Ord.ordInt)(x)(m);
    })([ 0, 1, 2 ]);
};
var getEnemyAtPosition = function (p) {
    return function (v) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_FoldableWithIndex.findWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (eid) {
            return function (v1) {
                return Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v1.location)(p);
            };
        })(v.enemies))(function (v1) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(v1.index);
        });
    };
};
var getTargetAtPosition = function (p) {
    return function (gs) {
        var v = getItemAtPosition(p)(gs);
        var v1 = getEnemyAtPosition(p)(gs);
        if (v1 instanceof Data_Maybe.Just) {
            return new TargetEnemy(v1.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Just) {
            return new TargetItem(v.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Nothing) {
            return TargetTerrain.create(getTerrainAtPosition(p)(gs));
        };
        throw new Error("Failed pattern match at GameState (line 600, column 28 - line 603, column 64): " + [ v1.constructor.name, v.constructor.name ]);
    };
};
var genNewOrgans = function (gs) {
    return gs;
};
var genNewMap = withRandom(function (v) {
    var conf = {
        width: Data_Terrain.arena.width,
        height: Data_Terrain.arena.height,
        minBlock: 3,
        maxBlock: 8
    };
    return Control_Bind.bind(Random_Gen.bindRandom)(Mapgen.generateMapFull(conf))(function (v1) {
        var roomInfo = Data_Functor.mapFlipped(Data_Functor.functorArray)(v1.rooms)(function (room) {
            return {
                room: room,
                perimeter: Data_Terrain.perimeter(room),
                visible: false
            };
        });
        var distanceToPlayer = function (v2) {
            var v3 = Data_Ring.sub(Extra_Math.ringVector(Data_Ring.ringInt))(v2)(v.p);
            return (0 - Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt)(v3.x) | 0) - Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt)(v3.y) | 0;
        };
        var exit = Extra_Prelude.unsafeFromJust(Data_Array.head(Data_Array.sortBy(Data_Ord.comparing(Data_Ord.ordInt)(distanceToPlayer))(v1.exitCandidates)));
        var terrain = Data_Terrain.placeExit(exit)(Data_Terrain.placeDoors(v1.doors)(Data_Terrain.carveRooms(v1.rooms)(Data_Terrain.bareMap)));
        var candidatePlayerLocs = Data_Array.filter(function (p) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Terrain.terrainEq))(Data_LinearIndex.index(terrain)(p))(new Data_Maybe.Just(Data_Terrain.Floor.value));
        })(Data_Array.cons(v.p)(Data_Functor.mapFlipped(Data_Functor.functorArray)(Framework_Direction.directions8)(function (d) {
            return Framework_Direction.move(Data_Ring.ringInt)(d)(v.p);
        })));
        return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.unsafeElement("spawnlocation")(candidatePlayerLocs))(function (newP) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)({
                p: newP,
                playerHealth: v.playerHealth,
                playerDistanceMap: v.playerDistanceMap,
                playerWeapons: v.playerWeapons,
                playerCurrentWeapon: v.playerCurrentWeapon,
                enemies: Data_Map_Internal.empty,
                items: Data_Map_Internal.empty,
                terrain: terrain,
                rooms: Data_Map_Internal.fromFoldable(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "width";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "height";
                }))(Data_Ord.ordInt)))(Data_Foldable.foldableArray)(Data_Array.zip(v1.rooms)(roomInfo)),
                level: v.level,
                availableOrgans: v.availableOrgans,
                events: v.events,
                rng: v.rng,
                nextId: v.nextId,
                installedOrgans: v.installedOrgans,
                removedOrgans: v.removedOrgans
            });
        });
    });
});
var genItem = function (location) {
    return function (v) {
        var d = levelDepth(v.level);
        return Control_Applicative.pure(Random_Gen.applicativeRandom)({
            location: location,
            decay: 15,
            tag: new Data_Item.HealthPickup(5)
        });
    };
};
var genHealth = function (v) {
    var bounds = {
        x: 0,
        y: 0,
        width: 6,
        height: 6
    };
    var armorOrgan = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.Armor.value);
    return Control_Bind.bind(Random_Gen.bindRandom)(rollLocations(v.armor)(bounds))(function (as) {
        return Control_Bind.bind(Random_Gen.bindRandom)(rollLocations(v.hp)(bounds))(function (hs) {
            return Control_Bind.bind(Random_Gen.bindRandom)(rollLocations(v.injuries)(bounds))(function (is) {
                return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Board.injureMulti(is)(Data_Board.addOrgans(hs)(hpOrgan1)(Data_Board.addOrgans(as)(armorOrgan)(Data_Board.freshHealth))));
            });
        });
    });
};
var genEnemy = function (location) {
    return function (v) {
        var d = levelDepth(v.level);
        var candidates = Data_Array.filter(function (x) {
            return (Data_Enemy.stats(x)).minDepth <= d;
        })(Data_Enemy.allEnemies);
        return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.unsafeElement("genEnemy")(candidates))(function (tag) {
            return Control_Bind.bind(Random_Gen.bindRandom)(genHealth(Data_Enemy.stats(tag)))(function (health) {
                return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Enemy.recalculateClues({
                    location: location,
                    health: health,
                    tag: tag,
                    clueCache: Data_Map_Internal.empty
                }));
            });
        });
    };
};
var freshTerrainFromString = function (s) {
    var s$prime = Data_Terrain.flatten(s);
    var t = Data_Functor.map(Data_Functor.functorArray)(Data_Terrain.charToTerrain)(Data_String_CodeUnits.toCharArray(s$prime));
    var $220 = Data_String_CodePoints.length(s$prime) === (Data_Terrain.arena.width * Data_Terrain.arena.height | 0);
    if ($220) {
        return Data_Maybe.Just.create({
            width: Data_Terrain.arena.width,
            height: Data_Terrain.arena.height,
            values: t
        });
    };
    return Data_Maybe.Nothing.value;
};
var freshPlayerOrgans = Data_Board.insertOrgan(Extra_Math.vec(3)(3))(playerHpOrgan)(Data_Board.insertOrgan(Extra_Math.vec(3)(0))(playerHpOrgan)(Data_Board.insertOrgan(Extra_Math.vec(5)(4))(humanEye)(Data_Board.insertOrgan(Extra_Math.vec(0)(3))(playerHpOrgan)(Data_Board.insertOrgan(Extra_Math.vec(1)(1))(humanEye)(Data_Board.emptyBag)))));
var freshPlayerBoard = {
    organs: freshPlayerOrgans,
    injuries: Data_Set.empty
};
var freshPlayerHealth = Data_Board.fromBoard(freshPlayerBoard);
var eyeV = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.EyeVert.value);
var eyeRed = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.EyeRed.value);
var eyeH = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.EyeHoriz.value);
var eyeBlue = new Data_Board.Organ(new Data_Board.OrganSize(1, 1), Data_Board.EyeBlue.value);
var generatableOrgans = [ o(playerHpOrgan)(6), o(eyeRed)(2), o(eyeBlue)(1), o(hpOrgan1)(1) ];
var genSurgeryRoomOrgans = withRandom(function (v) {
    var d = levelDepth(v.level);
    return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.intRange(2)(2 + d | 0))(function (numOrgans) {
        return Control_Bind.bind(Random_Gen.bindRandom)(rollLocations(numOrgans)({
            x: 0,
            y: 0,
            width: 8,
            height: 8
        }))(function (locations) {
            return Control_Bind.bind(Random_Gen.bindRandom)(Data_Traversable["for"](Random_Gen.applicativeRandom)(Data_Traversable.traversableArray)(locations)(function (pos) {
                return Data_Functor.map(Random_Gen.functorRandom)(function (v1) {
                    return v1.organ;
                })(Random_Gen.unsafeWeightedElement("genSurgery")(function (v1) {
                    return v1.weight;
                })(generatableOrgans));
            }))(function (organs) {
                var tryInsertOrgan = function (pos) {
                    return function (organ) {
                        return function (bag) {
                            var $222 = Data_Board.canInsertOrgan(pos)(organ)(bag);
                            if ($222) {
                                return Data_Board.insertOrgan(pos)(organ)(bag);
                            };
                            return bag;
                        };
                    };
                };
                var available = Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v1) {
                    return function (bag) {
                        return tryInsertOrgan(v1.value0)(v1.value1)(bag);
                    };
                })(Data_Board.emptyBag)(Data_Array.zip(locations)(organs));
                return Control_Applicative.pure(Random_Gen.applicativeRandom)({
                    p: v.p,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: v.enemies,
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: available,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                });
            });
        });
    });
});
var exampleRoombaBoard = {
    organs: Data_Board.insertOrgan(Extra_Math.vec(4)(0))(hpOrgan1)(Data_Board.insertOrgan(Extra_Math.vec(2)(5))(hpOrgan1)(Data_Board.insertOrgan(Extra_Math.vec(2)(2))(hpOrgan1)(Data_Board.emptyBag))),
    injuries: Data_Set.empty
};
var exampleOrgans = Data_Board.insertOrgan(Extra_Math.vec(6)(8))(playerHpOrgan)(Data_Board.insertOrgan(Extra_Math.vec(4)(4))(playerHpOrgan)(Data_Board.emptyBag));
var exampleItems = Data_Map_Internal.fromFoldableWithIndex(Data_Ord.ordInt)(Data_FoldableWithIndex.foldableWithIndexArray)([ {
    location: {
        x: 10,
        y: 10
    },
    decay: 10,
    tag: new Data_Item.HealthPickup(Data_Item.medium)
} ]);
var exampleInjuries = [ Extra_Math.vec(1)(1), Extra_Math.vec(2)(3), Extra_Math.vec(4)(4) ];
var exampleEnemies = Data_Map_Internal.fromFoldableWithIndex(Data_Ord.ordInt)(Data_FoldableWithIndex.foldableWithIndexArray)([ Data_Enemy.injureEnemyMulti(exampleInjuries)({
    location: {
        x: 5,
        y: 5
    },
    health: Data_Board.fromBoard(exampleRoombaBoard),
    clueCache: Data_Map_Internal.empty,
    tag: Data_Enemy.Fridge.value
}) ]);
var enemyMove = function (v) {
    return function (eid) {
        return function (newE) {
            return function (moveDir) {
                return reportEvent(new EnemyMoved(eid, moveDir))({
                    p: v.p,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: Data_Map_Internal.insert(Data_Ord.ordInt)(eid)(newE)(v.enemies),
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: v.availableOrgans,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                });
            };
        };
    };
};
var enemyAttack = function (g) {
    return function (eid) {
        var go = function (v) {
            var canAttack = Data_Eq.notEq(Data_Maybe.eqMaybe(Data_Terrain.terrainEq))(new Data_Maybe.Just(Data_Terrain.DoorClosed.value))(Data_LinearIndex.index(v.terrain)(v.p));
            return Control_Bind.bind(Random_Gen.bindRandom)(Data_Board.randomUninjuredSpace(v.playerHealth.board))(function (mattack) {
                if (canAttack && mattack instanceof Data_Maybe.Just) {
                    var newHealth = Data_Board.injure(mattack.value0)(v.playerHealth);
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)((function () {
                        var $234 = Data_Board.isAlive(newHealth);
                        if ($234) {
                            return reportEvent(new EnemyAttacked(eid, mattack.value0));
                        };
                        return reportEvent(PlayerDied.value);
                    })()({
                        p: v.p,
                        playerHealth: newHealth,
                        playerDistanceMap: v.playerDistanceMap,
                        playerWeapons: v.playerWeapons,
                        playerCurrentWeapon: v.playerCurrentWeapon,
                        enemies: v.enemies,
                        items: v.items,
                        terrain: v.terrain,
                        rooms: v.rooms,
                        level: v.level,
                        availableOrgans: v.availableOrgans,
                        events: v.events,
                        rng: v.rng,
                        nextId: v.nextId,
                        installedOrgans: v.installedOrgans,
                        removedOrgans: v.removedOrgans
                    }));
                };
                return Control_Applicative.pure(Random_Gen.applicativeRandom)(g);
            });
        };
        return withRandom(go)(g);
    };
};
var enemyAction = function (eid) {
    return function (v) {
        return withRandom(function (v1) {
            var isFree = function (v2) {
                return Data_Maybe.isNothing(getEnemyAtPosition(v2.target)(v1)) && isPassable(v2.target)(v1);
            };
            var candidates = Data_Functor.mapFlipped(Data_Functor.functorArray)(Framework_Direction.directions8)(function (dir) {
                var target = Framework_Direction.move(Data_Ring.ringInt)(dir)(v.location);
                return {
                    dir: dir,
                    target: target,
                    dist: Data_Maybe.fromMaybe(1000)(Data_Map_Internal.lookup(Extra_Math.ordVector(Data_Ord.ordInt))(target)(v1.playerDistanceMap))
                };
            });
            var freeSpaces = Data_Array.filter(isFree)(candidates);
            var minDist = Data_Maybe.fromMaybe(1000)(Data_Foldable.minimum(Data_Ord.ordInt)(Data_Foldable.foldableArray)(Data_Functor.mapFlipped(Data_Functor.functorArray)(freeSpaces)(function (v2) {
                return v2.dist;
            })));
            var goodCandidates = Data_Array.filter(function (c) {
                return c.dist === minDist;
            })(freeSpaces);
            var v2 = Data_Array_NonEmpty.fromArray(goodCandidates);
            if (v2 instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Random_Gen.applicativeRandom)(v1);
            };
            if (v2 instanceof Data_Maybe.Just) {
                return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.element(v2.value0))(function (v3) {
                    var newE = (function () {
                        var $243 = v3.dist < 1000;
                        if ($243) {
                            return {
                                location: v3.target,
                                health: v.health,
                                clueCache: v.clueCache,
                                tag: v.tag
                            };
                        };
                        return v;
                    })();
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)((function () {
                        var v4 = Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v3.target)(v1.p);
                        var v5 = v3.dist < 1000;
                        if (!v5) {
                            return v1;
                        };
                        if (v5 && v4) {
                            return enemyAttack(v1)(eid);
                        };
                        if (v5 && !v4) {
                            return enemyMove(v1)(eid)(newE)(Framework_Direction.dirVector(Data_Ring.ringInt)(v3.dir));
                        };
                        throw new Error("Failed pattern match at GameState (line 661, column 17 - line 665, column 43): " + [ v5.constructor.name, v4.constructor.name ]);
                    })());
                });
            };
            throw new Error("Failed pattern match at GameState (line 654, column 3 - line 665, column 43): " + [ v2.constructor.name ]);
        });
    };
};
var enemyTurn = function (v) {
    return Data_FoldableWithIndex.foldrWithIndex(Data_Map_Internal.foldableWithIndexMap)(enemyAction)(v)(v.enemies);
};
var decayItems = function (v) {
    var newItems = Data_Functor.map(Data_Map_Internal.functorMap)(function (v1) {
        return {
            location: v1.location,
            decay: v1.decay - 1 | 0,
            tag: v1.tag
        };
    })(v.items);
    return {
        p: v.p,
        playerHealth: v.playerHealth,
        playerDistanceMap: v.playerDistanceMap,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: v.enemies,
        items: newItems,
        terrain: v.terrain,
        rooms: v.rooms,
        level: v.level,
        availableOrgans: v.availableOrgans,
        events: v.events,
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: v.installedOrgans,
        removedOrgans: v.removedOrgans
    };
};
var convertActionIfDead = function (v) {
    return function (a) {
        if (v.level instanceof Dead) {
            return StartNewGame.value;
        };
        return a;
    };
};
var clearEvents = function (v) {
    return {
        p: v.p,
        playerHealth: v.playerHealth,
        playerDistanceMap: v.playerDistanceMap,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: v.enemies,
        items: v.items,
        terrain: v.terrain,
        rooms: v.rooms,
        level: v.level,
        availableOrgans: v.availableOrgans,
        events: [  ],
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: v.installedOrgans,
        removedOrgans: v.removedOrgans
    };
};
var cleanupItems = function (v) {
    return {
        p: v.p,
        playerHealth: v.playerHealth,
        playerDistanceMap: v.playerDistanceMap,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: v.enemies,
        items: Data_Map_Internal.filter(Data_Ord.ordInt)(function (v2) {
            return v2.decay > 0;
        })(v.items),
        terrain: v.terrain,
        rooms: v.rooms,
        level: v.level,
        availableOrgans: v.availableOrgans,
        events: v.events,
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: v.installedOrgans,
        removedOrgans: v.removedOrgans
    };
};
var canInstallOrgan = function (pos) {
    return function (organ) {
        return function (v) {
            var o1 = Data_Tuple.fst(organ);
            var bag = (function (v1) {
                return v1.organs;
            })(Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)((function (v1) {
                return v1.board;
            })(Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth))));
            return Data_Board.canInsertOrgan(pos)(o1)(bag) && Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Board.isValidBoardCoord)(Data_Board.extent(o1)(pos));
        };
    };
};
var addItem = function (i) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: v.enemies,
            items: Data_Map_Internal.insert(Data_Ord.ordInt)(v.nextId)(i)(v.items),
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId + 1 | 0,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var addEnemy = function (e) {
    return function (v) {
        return {
            p: v.p,
            playerHealth: v.playerHealth,
            playerDistanceMap: v.playerDistanceMap,
            playerWeapons: v.playerWeapons,
            playerCurrentWeapon: v.playerCurrentWeapon,
            enemies: Data_Map_Internal.insert(Data_Ord.ordInt)(v.nextId)(e)(v.enemies),
            items: v.items,
            terrain: v.terrain,
            rooms: v.rooms,
            level: v.level,
            availableOrgans: v.availableOrgans,
            events: v.events,
            rng: v.rng,
            nextId: v.nextId + 1 | 0,
            installedOrgans: v.installedOrgans,
            removedOrgans: v.removedOrgans
        };
    };
};
var populateRoom = function (v) {
    return function (room) {
        var weight = function (v1) {
            if (v1 === 0) {
                return 2;
            };
            if (v1 === 1) {
                return 4;
            };
            return 2;
        };
        return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.unsafeWeightedElement("populateRoom")(weight)([ 0, 1, 2 ]))(function (numberOfEnemies) {
            return Control_Bind.bind(Random_Gen.bindRandom)(Data_Functor.map(Random_Gen.functorRandom)((function () {
                var $299 = Data_Array.filter(function (x) {
                    return Data_Eq.notEq(Extra_Math.eqVector(Data_Eq.eqInt))(x)(v.p);
                });
                return function ($300) {
                    return Data_Array.uncons($299($300));
                };
            })())(rollLocations(1 + numberOfEnemies | 0)(room)))(function (muncons) {
                if (muncons instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)(v);
                };
                if (muncons instanceof Data_Maybe.Just) {
                    return Control_Bind.bind(Random_Gen.bindRandom)(genItem(muncons.value0.head)(v))(function (item) {
                        return Control_Bind.bind(Random_Gen.bindRandom)(Data_Traversable["for"](Random_Gen.applicativeRandom)(Data_Traversable.traversableArray)(muncons.value0.tail)(function (p) {
                            return genEnemy(p)(v);
                        }))(function (enemies) {
                            return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Function.flip(Data_Foldable.foldr(Data_Foldable.foldableArray)(addEnemy))(Data_Array.filter(Data_Enemy.isAlive)(enemies))(addItem(item)(v)));
                        });
                    });
                };
                throw new Error("Failed pattern match at GameState (line 445, column 3 - line 452, column 69): " + [ muncons.constructor.name ]);
            });
        });
    };
};
var revealRooms = withRandom(function (v) {
    var hiddenRooms = Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.values(Data_Map_Internal.filter(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "width";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "height";
    }))(Data_Ord.ordInt)))((function () {
        var $301 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($302) {
            return $301((function (v1) {
                return v1.visible;
            })($302));
        };
    })())(v.rooms)));
    var roomToReveal = Data_Foldable.find(Data_Foldable.foldableArray)(function (r) {
        return Data_Terrain.insideBlock(v.p)(r.perimeter);
    })(hiddenRooms);
    if (roomToReveal instanceof Data_Maybe.Nothing) {
        return Control_Applicative.pure(Random_Gen.applicativeRandom)(v);
    };
    if (roomToReveal instanceof Data_Maybe.Just) {
        return Control_Bind.bind(Random_Gen.bindRandom)(populateRoom(v)(roomToReveal.value0.room))(function (g$prime) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(markVisible(roomToReveal.value0.room)(reportEvent(new RoomRevealed(roomToReveal.value0.room))(g$prime)));
        });
    };
    throw new Error("Failed pattern match at GameState (line 534, column 7 - line 540, column 34): " + [ roomToReveal.constructor.name ]);
});
var die = function (v) {
    return recalculatePDMap(revealRooms(genSurgeryRoomOrgans(genNewMap({
        p: startingPos,
        playerHealth: freshPlayerHealth,
        playerDistanceMap: Data_Map_Internal.empty,
        playerWeapons: v.playerWeapons,
        playerCurrentWeapon: v.playerCurrentWeapon,
        enemies: Data_Map_Internal.empty,
        items: Data_Map_Internal.empty,
        terrain: Data_Terrain.bareMap,
        rooms: Data_Map_Internal.empty,
        level: Dead.value,
        availableOrgans: exampleOrgans,
        events: [  ],
        rng: v.rng,
        nextId: v.nextId,
        installedOrgans: 0,
        removedOrgans: 0
    }))));
};
var checkDeath = function (v) {
    var $279 = v.playerHealth.hpCount <= 0;
    if ($279) {
        return die(v);
    };
    return v;
};
var handleAction = function (v) {
    return function (v1) {
        if (v1 instanceof Move) {
            var p$prime = Framework_Direction.move(Data_Ring.ringInt)(v1.value0)(v.p);
            var v2 = getItem(p$prime)(v);
            var v3 = isExit(p$prime)(v);
            var v4 = isPassable(p$prime)(v);
            if (!v4) {
                return new Data_Either.Left(new FailedAction(v1.value0));
            };
            if (v4 && (!v3 && v2 instanceof Data_Maybe.Nothing)) {
                return Data_Either.Right.create(openDoorAt(p$prime)(enemyTurn(recalculatePDMap(revealRooms(reportEvent(new PlayerMoved(v1.value0))({
                    p: p$prime,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: v.enemies,
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: v.availableOrgans,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                }))))));
            };
            if (v4 && (!v3 && v2 instanceof Data_Maybe.Just)) {
                return Data_Either.Right.create(openDoorAt(p$prime)(enemyTurn(recalculatePDMap(revealRooms(reportEvent(new ItemUsed(v2.value0.item))(reportEvent(new PlayerMoved(v1.value0))(useItem(v2.value0.iid)(withRandom(healMany(v2.value0.item))({
                    p: p$prime,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: v.enemies,
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: v.availableOrgans,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                })))))))));
            };
            if (v4 && v3) {
                return Data_Either.Right.create(recalculatePDMap(genNewOrgans(revealRooms(genSurgeryRoomOrgans(genNewMap(reportEvent(new PlayerMoved(v1.value0))(goToNextLevel({
                    p: p$prime,
                    playerHealth: v.playerHealth,
                    playerDistanceMap: v.playerDistanceMap,
                    playerWeapons: v.playerWeapons,
                    playerCurrentWeapon: v.playerCurrentWeapon,
                    enemies: v.enemies,
                    items: v.items,
                    terrain: v.terrain,
                    rooms: v.rooms,
                    level: v.level,
                    availableOrgans: v.availableOrgans,
                    events: v.events,
                    rng: v.rng,
                    nextId: v.nextId,
                    installedOrgans: v.installedOrgans,
                    removedOrgans: v.removedOrgans
                }))))))));
            };
            throw new Error("Failed pattern match at GameState (line 247, column 7 - line 271, column 27): " + [ v4.constructor.name, v3.constructor.name, v2.constructor.name ]);
        };
        if (v1 instanceof Attack) {
            var menemy = Data_Map_Internal.lookup(Data_Ord.ordInt)(v1.value1)(v.enemies);
            if (menemy instanceof Data_Maybe.Nothing) {
                return new Data_Either.Left(FailedAttack.value);
            };
            if (menemy instanceof Data_Maybe.Just) {
                var $290 = Data_Board.validTarget(v1.value0)(menemy.value0.health);
                if ($290) {
                    return Data_Either.Right.create(enemyTurn(reportEvent(new PlayerAttacked(v1.value1))(handleEnemyInjury(v)(menemy.value0)(v1.value1)(v1.value0))));
                };
                return new Data_Either.Left(FailedAttack.value);
            };
            throw new Error("Failed pattern match at GameState (line 275, column 7 - line 282, column 31): " + [ menemy.constructor.name ]);
        };
        if (v1 instanceof InstallOrgan) {
            var $295 = canInstallOrgan(v1.value1)(v1.value0)(v);
            if ($295) {
                return Data_Either.Right.create(removeAvailableOrgan(v1.value0)(installOrgan(v1.value1)(Data_Tuple.fst(v1.value0))(v)));
            };
            return new Data_Either.Left(FailedInstall.value);
        };
        if (v1 instanceof RemoveOrgan) {
            return Data_Either.Right.create(removeOrgan(v1.value0)(v));
        };
        if (v1 instanceof FinishSurgery) {
            return Data_Either.Right.create(goToNextLevel(v));
        };
        if (v1 instanceof StartNewGame) {
            return Data_Either.Right.create(goToNextLevel(v));
        };
        return Data_Either.Right.create(v);
    };
};
var step = function (gs) {
    return function (a) {
        return handleAction(clearEvents(checkDeath(cleanupItems(decayItems(gs)))))(convertActionIfDead(checkDeath(gs))(a));
    };
};
var initState = function __do() {
    var random = Random_Gen.newGen();
    return recalculatePDMap(revealRooms(genSurgeryRoomOrgans(genNewMap({
        p: startingPos,
        playerHealth: freshPlayerHealth,
        playerDistanceMap: Data_Map_Internal.empty,
        playerWeapons: Data_Map_Internal.singleton(0)(Data_Item.pistol),
        playerCurrentWeapon: 0,
        enemies: Data_Map_Internal.empty,
        items: Data_Map_Internal.empty,
        level: NewGame.value,
        availableOrgans: exampleOrgans,
        events: [  ],
        rng: random,
        terrain: Data_Terrain.bareMap,
        rooms: Data_Map_Internal.empty,
        nextId: 100,
        installedOrgans: 0,
        removedOrgans: 0
    }))));
};
module.exports = {
    initState: initState,
    die: die,
    startingPos: startingPos,
    exampleEnemies: exampleEnemies,
    exampleItems: exampleItems,
    exampleInjuries: exampleInjuries,
    exampleRoombaBoard: exampleRoombaBoard,
    exampleOrgans: exampleOrgans,
    freshTerrainFromString: freshTerrainFromString,
    freshPlayerHealth: freshPlayerHealth,
    freshPlayerOrgans: freshPlayerOrgans,
    freshPlayerBoard: freshPlayerBoard,
    hpOrgan1: hpOrgan1,
    playerHpOrgan: playerHpOrgan,
    humanEye: humanEye,
    eyeRed: eyeRed,
    eyeBlue: eyeBlue,
    eyeH: eyeH,
    eyeV: eyeV,
    isWall: isWall,
    isFloor: isFloor,
    isOpenDoor: isOpenDoor,
    step: step,
    checkDeath: checkDeath,
    convertActionIfDead: convertActionIfDead,
    handleAction: handleAction,
    handleEnemyInjury: handleEnemyInjury,
    isPassable: isPassable,
    isExit: isExit,
    isItem: isItem,
    getItem: getItem,
    inWorldBounds: inWorldBounds,
    useItem: useItem,
    decayItems: decayItems,
    cleanupItems: cleanupItems,
    PlayerMoved: PlayerMoved,
    EnemyMoved: EnemyMoved,
    PlayerAttacked: PlayerAttacked,
    EnemyAttacked: EnemyAttacked,
    PlayerDied: PlayerDied,
    EnemyDied: EnemyDied,
    RoomRevealed: RoomRevealed,
    ItemUsed: ItemUsed,
    GameState: GameState,
    openDoorAt: openDoorAt,
    withRandom: withRandom,
    genNewMap: genNewMap,
    genNewOrgans: genNewOrgans,
    recalculatePDMap: recalculatePDMap,
    populateRoom: populateRoom,
    rollLocations: rollLocations,
    genItem: genItem,
    genEnemy: genEnemy,
    genHealth: genHealth,
    o: o,
    generatableOrgans: generatableOrgans,
    genSurgeryRoomOrgans: genSurgeryRoomOrgans,
    revealRooms: revealRooms,
    markVisible: markVisible,
    addItem: addItem,
    addEnemy: addEnemy,
    Regular: Regular,
    Surgery: Surgery,
    NewGame: NewGame,
    Dead: Dead,
    Victory: Victory,
    isSurgeryLevel: isSurgeryLevel,
    nextLevel: nextLevel,
    levelDepth: levelDepth,
    goToNextLevel: goToNextLevel,
    clearEvents: clearEvents,
    reportEvent: reportEvent,
    TargetEnemy: TargetEnemy,
    TargetItem: TargetItem,
    TargetTerrain: TargetTerrain,
    getTargetAtPosition: getTargetAtPosition,
    getEnemyAtPosition: getEnemyAtPosition,
    getItemAtPosition: getItemAtPosition,
    getTerrainAtPosition: getTerrainAtPosition,
    Move: Move,
    Attack: Attack,
    SelectWeapon: SelectWeapon,
    InstallOrgan: InstallOrgan,
    RemoveOrgan: RemoveOrgan,
    FinishSurgery: FinishSurgery,
    StartNewGame: StartNewGame,
    FailedAction: FailedAction,
    FailedAttack: FailedAttack,
    FailedInstall: FailedInstall,
    enemyTurn: enemyTurn,
    enemyAction: enemyAction,
    enemyMove: enemyMove,
    enemyAttack: enemyAttack,
    canInstallOrgan: canInstallOrgan,
    installOrgan: installOrgan,
    removeAvailableOrgan: removeAvailableOrgan,
    removeOrgan: removeOrgan,
    healOne: healOne,
    healMany: healMany,
    getFreeWeaponSlot: getFreeWeaponSlot,
    placeWeapon: placeWeapon,
    pickUpWeapon: pickUpWeapon,
    selectWeapon: selectWeapon
};
